import _ from 'lodash';
import InsightsApi from '../../api/InsightsApi';

const INSIGHT_NAMES = {
  // transaction insights (on specific transactions)
  HighExpense: 'highExpense',
  RelativeHighExpense: 'relativeHighExpense',
  HighIncomeExclusion: 'highIncomeExclusion',
  RelativeIncomeExclusion: 'relativeIncomeExclusion',
  LoanExclusion: 'loanExclusion',
  MightBeFixed: 'mightBeFixed',
  // balance insights (on balance event)
  EconomyBalance: 'economyBalance',
  FixedBalance: 'fixedBalance',
  RecurringBalance: 'recurringBalance',

  ZeroBalance: 'zeroBalance',
  // tracking insight (first 2 days after activation)
  TrackingCategories: 'trackingCategories',
  // savings
  OpportunisticSaving: 'OpportunisticSaving',
  MonthlySaving: 'MonthlySaving',
  HarelMonthlySaving: 'HarelMonthlySaving',
  MeitavOpportunisticSaving: 'MeitavOpportunisticSaving',
  MeitavMonthlySaving: 'MeitavMonthlySaving',
  NewPapasMergeInsight: 'newPapasMergeInsight',
  SonsMergeInsight: 'SonsMergeInsight',
  AllClassifiedPapasMergeInsight: 'allClassifiedPapasMergeInsight',
  BalanceMoneyInsight: 'balanceMoneyInsight',
  // sumsum
  DemographicInfo: 'demographicInfo',
  // fees insight (first 2 weeks after activation)
  FeesInsight: 'feesInsight',
  NegativeBalanceInsight: 'negativeBalanceInsight',
  RiseupGoalInsight: 'riseupGoalInsight',
  RollingCreditInsight: 'rollingCredit',
  ChallengeInsight: 'challengeInsight',
  JoinAmbassadorsInsight: 'joinAmbassadorsInsight',
  TrackingCategoriesSelectionInsight: 'trackingCategoriesSelectionInsight',
};

const HIDDEN_INSIGHTS = [];
const KNOWN_INSIGHTS = _.difference(_.values(INSIGHT_NAMES), HIDDEN_INSIGHTS);

const EXCLUSION_INSIGHTS = [
  INSIGHT_NAMES.LoanExclusion,
  INSIGHT_NAMES.HighIncomeExclusion,
  INSIGHT_NAMES.HighExpense,
  INSIGHT_NAMES.RelativeIncomeExclusion,
  INSIGHT_NAMES.RelativeHighExpense,
];

const state = {
  insights: [],
};

const getters = {
  INSIGHT_NAMES: () => INSIGHT_NAMES,
  EXCLUSION_INSIGHTS: () => EXCLUSION_INSIGHTS,
  filteredInsights: (state, _, __, rootGetters) => state.insights.filter(insight => !insight.featureFlag
    || rootGetters['featureFlags/isFlagIsOn'](insight.featureFlag)),
};

const actions = {
  async initInsights({ commit }) {
    const insights = await InsightsApi.fetchInsights();
    const knownInsights = insights.filter(insight => KNOWN_INSIGHTS.includes(insight.insightName));
    commit('setInsights', knownInsights);
  },
  async clearInsight({ commit }, insight) {
    commit('clearInsight', insight.insightId);
  },
  async markAsRead({ commit }, insight) {
    commit('clearInsight', insight.insightId);
    await InsightsApi.markAsRead(insight.insightId, insight.insightName, insight);
  },
  async sendInsightFeedback({ commit }, { insight, feedback }) {
    await InsightsApi.sendInsightFeedback(insight.insightId, insight.insightName, insight, feedback);
  },
};

// mutations
const mutations = {
  setInsights(state, insights) {
    state.insights = insights;
  },
  clearInsight(state, insightId) {
    const indexToSlice = _.findIndex(state.insights, insight => insight.insightId === insightId);
    state.insights.splice(indexToSlice, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
